import { BASVURU_RUHSAT_TIPI_GUNCELLE } from "../constants/requestUrls";

import { postRequest } from "../request";

const parentBasvuruRuhsatTipiGuncelle = (props) => {
  let data = {};
  if (props !== undefined)
    data = JSON.stringify(props);

  return postRequest({ url: BASVURU_RUHSAT_TIPI_GUNCELLE, data });
}

export default parentBasvuruRuhsatTipiGuncelle;